export default function Footer() {
  return (
    <footer className="pf-footer">
      <p className="pf-footer__brand">虹嶺庵 KOUREIAN</p>
      <p className="pf-footer__copy">© {new Date().getFullYear()} Saiun Umetani. All rights reserved.</p>
    </footer>
  );
}
